export default function (url, decode) {
  url = url || location.href;
  var _paramArray = url.replace(/.*?\?/, '').replace(/#.*/, '').split('&');
  var params = {};

  for (var _idx in _paramArray) {
    if (_paramArray.hasOwnProperty(_idx)) {
      var row = _paramArray[_idx];
      var splitIdx = row.indexOf('=');
      if (splitIdx > 0) {
        var key = row.substring(0, splitIdx);
        var value = row.substring(splitIdx + 1);
        if (decode) {
          try {
            value = decodeURIComponent(value)
          } catch (e) {
            value = '';
          }
        }
        params[key] = value;
      }
    }
  }
  return params;
}
